import { AbstractPmsApiService } from './abstract.service';
import { CreditViewableUser } from '../models';

/**
 * @class CreditCardSecurityPmsApiService
 * @extends {AbstractPmsApiService<CreditViewableUser>}
 */
export class CreditCardSecurityPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/credit-card-security(/:path)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {CreditViewableUser}
     * @protected
     */
    newModel(attributes, ...params) {

        return new CreditViewableUser(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property} property
     * @returns {Promise.<Array<CreditViewableUser>>}
     */
    get(params = {}, property) {

        const url = this.url({
            propertyId: property.id,
        });
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getMassModeler())
            .then(users => {

                users[0].access = true;
                users[0].disabled = true;

                return users;
            })
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {CreditViewableUser} user
     * @returns {Promise.<Boolean>}
     */
    giveAccess(property, user) {

        const url = this.url({
            propertyId: property.id,
            path: `give-access/${user.id}`,
        });

        return this.doAccessOp(url);
    }

    /**
     * @param {Property} property
     * @param {CreditViewableUser} user
     * @returns {Promise.<Boolean>}
     */
    revokeAccess(property, user) {

        const url = this.url({
            propertyId: property.id,
            path: `revoke-access/${user.id}`,
        });

        return this.doAccessOp(url);
    }

    /**
     *
     * @param {Property} property
     * @param {CreditViewableUser} user
     * @return {*}
     */
    toggleAccess(property, user) {

        const method = user.access ? 'giveAccess' : 'revokeAccess';

        return this[method](property, user);
    }

    doAccessOp(url) {

        return this.http
            .post(url, {}, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    checkPermission(property) {

        const url = this.url({
            propertyId: property.id,
            path: 'check-permission',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .then(({has_permission}) => has_permission)
            .then(Boolean)
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/credit-card-security.service.js